import { apiVersion2Headers, client } from 'repositories/client';
import {
  CreateResponse,
  ValidateResponse,
} from 'repositories/emailVerification/responseType';
import { paths } from 'repositories/emailVerification/paths';
import { getRequestPath } from 'utils/string';

const create = async (email: string): Promise<CreateResponse> => {
  const response = await client.post<CreateResponse>(
    paths.create,
    { email },
    { headers: apiVersion2Headers() }
  );
  return response.data;
};

const validate = async (
  transactionKey: string,
  code: string
): Promise<ValidateResponse> => {
  const response = await client.post<ValidateResponse>(
    getRequestPath(paths.validate, { transactionKey }),
    { code },
    { headers: apiVersion2Headers() }
  );
  return response.data;
};

export const emailVarification = {
  create,
  validate,
};
